<div class="form-container">
    <form>
        <div class="form-group">
            <label for="comuna">Comuna</label>
            <div class="input-wrapper">
                <span class="icon" [class.visible]="showMessageComuna || isInputFocusedComuna">🔍</span>
                <input 
                    type="text" 
                    id="comuna" 
                    name="comuna"
                    (input)="onInputChange($event.target.value)"
                    (focus)="onFocus('comuna')"
                    (blur)="onBlur('comuna')"
                    [value]="selectedComuna">
                <ul *ngIf="showDropdownComuna" class="dropdown-list">
                    <li *ngIf="showMessageComuna" class="dropdown-items">
                        Ingrese 3 caracteres para la búsqueda
                    </li>
                    <li *ngFor="let comuna of filteredComunas" (click)="selectComuna(comuna)" class="dropdown-item">
                        {{ comuna.nombre }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="calle">Calle</label>
            <div class="input-wrapper">
                <span class="icon" [class.visible]="showMessageCalle || isInputFocusedCalle">🔍</span>
                <input 
                    type="text" 
                    id="calle" 
                    name="calle"
                    (input)="onCalleInputChange($event.target.value)"
                    (focus)="onFocus('calle')"
                    (blur)="onBlur('calle')"
                    [value]="selectedCalle"
                    [attr.autofocus]="false">
                <ul *ngIf="showDropdownCalle" class="dropdown-list">
                    <li *ngIf="showMessageCalle" class="dropdown-items">
                        Seleccione comuna primero........
                    </li>
                    <li *ngFor="let calle of filteredCalles" (click)="selectCalle(calle)" class="dropdown-item">
                        {{ calle.nombre }}
                    </li>
                </ul>
            </div>
        </div>        
        <div class="form-group">
            <label for="numero">Número</label>
            <div class="input-wrapper">
                <span class="icon" [class.visible]="showMessageNumero || isInputFocusedNumero">🔍</span>
                <input 
                    type="text" 
                    id="numero" 
                    name="numero"
                    (input)="onNumeroInputChange($event.target.value)"
                    (focus)="onFocus('numero')"
                    (blur)="onBlur('numero')"
                    [value]="selectedNumero"
                    [attr.autofocus]="false">
                <ul *ngIf="showDropdownNumero" class="dropdown-list">
                    <li *ngIf="showMessageNumero" class="dropdown-items">
                        Seleccione calle primero........
                    </li>
                    <li *ngFor="let numero of filteredNumeros" (click)="selectNumero(numero)" class="dropdown-item">
                        {{ numero.nombre }}
                    </li>
                </ul>
            </div>
        </div>  
        <div class="form-group">
            <label for="casa">Casa, Depto, Block</label>
            <div class="input-wrapper">
                <span class="icon" [class.visible]="showMessageCasa || isInputFocusedCasa">🔍</span>
                <input 
                    type="text" 
                    id="casa" 
                    name="casa"
                    (input)="onCasaInputChange($event.target.value)"
                    (focus)="onFocus('casa')"
                    (blur)="onBlur('casa')"
                    [value]="selectedCasa"
                    [attr.autofocus]="false">
                <ul *ngIf="showDropdownCasa" class="dropdown-list">
                    <li *ngIf="showMessageCasa" class="dropdown-items">
                        Seleccione número primero........
                    </li>
                    <li *ngFor="let casa of filteredCasas" (click)="selectCasa(casa)" class="dropdown-item">
                        {{ casa.nombre }}
                    </li>
                </ul>
            </div>
        </div>
    
        <div class="modal-footer">
            <button type="submit" (click)="searchCliente()" class="submit-btn">Buscar</button>
    
            <button type="button" (click)="cerrarModal()" class="close-btn">Salir</button>
        </div>
    
    </form>
</div>
